import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from '@/components/ui/sidebar';
import { useRouterState, Link } from '@tanstack/react-router';
import { cn } from '@/lib/utils';
import { AppSidebarFooter } from './AppSidebarFooter';
import { AppSidebarHeader } from './AppSidebarHeader';
import { CompanySwitcher } from './CompanySwitcher';
import { useTranslation } from '@/hooks/useTranslation';
import { BarChart2, FileUp, Settings, Sparkles } from 'lucide-react';
import { APP_ROUTES } from '@/const/routes';
import { useGetCrmConnections } from '@/queries/crm.queries';

interface IProps {
  isHidden?: boolean;
}

export interface IMenuEntry {
  label: string;
  to: string;
  icon?: React.ReactNode;
}

export const AppSidebar = ({ isHidden }: IProps) => {
  const { t } = useTranslation();
  const { location } = useRouterState();
  const pathname = location.pathname;
  const { data: crmConnections = [] } = useGetCrmConnections();
  const hasCrmConnected = crmConnections.some((c) => c.status === 'active');

  if (isHidden) return <></>;

  const menuItems: IMenuEntry[] = [
    {
      label: t('menu.general.360Analysis'),
      to: APP_ROUTES.app.analysis,
      icon: <BarChart2 className="size-4" />,
    },
    {
      label: t('menu.general.aiChat'),
      to: APP_ROUTES.app.aiChat,
      icon: <Sparkles className="size-4" />,
    },
    ...(!hasCrmConnected ? [{
      label: t('menu.general.dataImport'),
      to: APP_ROUTES.app.dataImport.index,
      icon: <FileUp className="size-4" />,
    }] : []),
    {
      label: 'Settings',
      to: APP_ROUTES.app.settings.index,
      icon: <Settings className="size-4" />,
    },
  ];

  return (
    <Sidebar collapsible="icon">
      <AppSidebarHeader />

      <SidebarSeparator />

      <div className="px-2 py-2">
        <CompanySwitcher />
      </div>

      <SidebarSeparator />

      <SidebarContent className="py-2">
        <SidebarGroup>
          <SidebarMenu>
            {menuItems.map((item) => {
              const isActive = pathname.startsWith(item.to);
              return (
                <SidebarMenuItem key={item.to}>
                  <SidebarMenuButton
                    tooltip={item.label}
                    isActive={isActive}
                    asChild
                    className={cn(
                      "bg-transparent hover:bg-secondary/10 data-[active=true]:bg-secondary/30",
                      "text-muted-foreground hover:text-sidebar-accent-foreground data-[active=true]:sidebar-accent-foreground",
                      // 'text-muted-foreground hover:text-foreground',
                      // isActive && '[&_svg]:text-chart-heatmap-6',
                    )}
                  // style={isActive ? {
                  //   '--sidebar-accent': '0 0% 100%',
                  //   '--sidebar-accent-foreground': 'var(--secondary-accent)',
                  // } as React.CSSProperties : undefined}
                  >
                    <Link to={item.to}>
                      {item.icon}
                      <span>{item.label}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              );
            })}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>

      <SidebarSeparator />

      <AppSidebarFooter />
    </Sidebar>
  );
};
